import { useCallback, useState } from "react";
import type { ProductsSeenMap } from "@/types/frontend-types";
import { selectUpdatedProductsSeen } from "./read-tracking-selectors";
import type {
  ReplaceProductsSeenInput,
  SessionProductsSeenState,
  UpdateProductsSeenInput,
} from "./use-session-read-tracking.types";

export function useSessionProductsSeenState(): SessionProductsSeenState {
  const [productsSeen, setProductsSeen] = useState<ProductsSeenMap>({});

  const replaceProductsSeen = useCallback(
    (input: ReplaceProductsSeenInput): void => {
      const { productsSeen: nextProductsSeen } = input;
      setProductsSeen(nextProductsSeen);
    },
    [],
  );

  const updateProductsSeen = useCallback(
    (input: UpdateProductsSeenInput): void => {
      const { productId, patch } = input;
      setProductsSeen((previous) =>
        selectUpdatedProductsSeen({ previous, productId, patch }),
      );
    },
    [],
  );

  const resetProductsSeen = useCallback((): void => {
    setProductsSeen({});
  }, []);

  return {
    productsSeen,
    replaceProductsSeen,
    resetProductsSeen,
    updateProductsSeen,
  };
}
